import { useCuepointsStore } from "../../../animator/useCuepointsStore";
import { postToIframe } from "../../../animator/utils";

export const useModifyColorAllHighlights = () => {
  const { updateCuepoints } = useCuepointsStore();

  const modifyColorAllHighlights = (color: string) => {
    console.log(color);
    updateCuepoints(color);
    postToIframe({
      type: "modify-all",
      roughNotation: {
        color,
      },
    });
  };

  return modifyColorAllHighlights;
};
